import React from 'react';
import './Products.css';
import { Link } from "react-router-dom";

const products = [
  {
    name: "Calviace-XT",
     link: "/products/calviace-xt",
    image: "/images/calviace.jpg",
     composition: "Calcium Carbonate, Vit D3, Methylcobalamin, L-Methylfolate, Pyridoxal-5-Phosphate",
    dosage: "As directed by the physician.",
    
  },
  {
    name: "Thioxigen-4",
     link: "/products/calviace-xt",
     image: "/images/thioxigen.jpg",
     composition: "Etoricoxib + Thiocolchicoside",
    dosage: "As directed by the physician.",

  },
  {
    name: "Norviace-NT",
     link: "/products/calviace-xt",
     image: "/images/norviace.jpg",
     composition: "Pregabalin (SR), Methylcobalamin, Nortriptyline",
    dosage: "As directed by the physician.",
    
  }, 
  {
    name: "Torviset",
     link: "/products/calviace-xt",
    image: "/images/Torviset.jpg",
     composition: "Torsemide 10mg/20mg/40mg",
    dosage: "As directed by the physician.",
    
  },
   {
    name: "Nitrozex",
     link: "/products/calviace-xt",
    image: "/images/Nitrozex.jpg",
     composition: "Nitroglycerin 2.6 mg/6.4",
    dosage: "As directed by the physician.",

  },
  {
    name: "Esciwon plus",
     link: "/products/calviace-xt",
     image: "/images/esciwon plus.jpg",
     composition: " Escitalopram (10 mg) + Clonazepam (0.5 mg)",
    dosage: "As directed by the physician.",
    
  }
];

const Products = () => {
  return (
    <section className="products-section">
      <h2>Our Products</h2>
      <div className="product-grid">
        {products.map((p, index) => (
          <div className="product-card" key={index} tabIndex="0" aria-label={`Product ${p.name}`}>
            <img src={p.image} alt={p.name} className="product-image" loading="lazy" />
            <div className="product-info">
              <h3>{p.name}</h3>
              <p><strong>Composition:</strong> {p.composition}</p>
              <p><strong>Dosage:</strong> {p.dosage}</p>
<Link
  to={p.link}
  className="view-btn"
  onClick={() => window.scrollTo(0, 0)}
>
  View Details
</Link>            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;
